import opinionTradingSlice from "./slices/opinionTradingSlice";
import predictionSlice from "./slices/predictionSlice";
import inPlaySlice from "./slices/inPlaySlice";
import loginSlice from "./slices/loginSlice";
import userSlice from "./slices/user";
import skillerSlice from "./slices/skillerSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import predictInfo from "./slices/predictInfoSlice";
import categorySlice from "./slices/categorySlice";

const persistConfig = {
  key: 'prediction',
  blacklist: ['userSlice', 'prediction', 'opinionTrading', 'inPlaySlice', 'predictInfo', 'categorySlice', 'skillerSlice'],
  version: 1,
  storage,
}

const rootReducer = combineReducers({
  prediction: predictionSlice,
  opinionTrading: opinionTradingSlice,
  inPlaySlice: inPlaySlice,
  loginSlice: loginSlice,
  userSlice: userSlice,
  skillerSlice: skillerSlice,
  predictInfo: predictInfo,
  categorySlice: categorySlice
})

const persistedReducer = persistReducer(persistConfig, rootReducer)



export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export let persistor = persistStore(store)
